/*
  Sandy Shindig motion layer.
  Scroll reveal: the top-level content of each section fades up as it enters the viewport, staggered.
  Images ease out of a slight zoom as they reveal. Toggle in Theme settings > Sandy Shindig.
  Disabled for prefers-reduced-motion and inside the theme editor.
*/
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = window.Shopify && window.Shopify.designMode;
  if (reduceMotion || designMode || !('IntersectionObserver' in window)) return;

  function initReveal() {
    document.documentElement.classList.add('sandy-motion');

    // Top-level blocks only, so carousels and grids reveal as one unit
    // (off-screen carousel slides never intersect the viewport on their own).
    const targets = [...document.querySelectorAll('main .shopify-section .section-content-wrapper > *')].filter(
      (el) => !['STYLE', 'SCRIPT', 'LINK', 'TEMPLATE'].includes(el.tagName) && el.getClientRects().length > 0
    );

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-inview');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    targets.forEach((el) => {
      if (el.closest('.sandy-no-reveal') || el.querySelector('.sandy-no-reveal') || el.classList.contains('sandy-reveal')) return;
      // Anything already on screen at load stays put, so the first paint never flashes.
      if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
      const siblings = [...el.parentElement.children];
      el.style.setProperty('--sandy-delay', `${Math.min(siblings.indexOf(el), 5) * 90}ms`);
      el.classList.add('sandy-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReveal);
  } else {
    initReveal();
  }
})();
